import * as React from 'react';

import * as ReactDOM from 'react-dom/client';

import { App } from './app';
import { enableMocking } from './mocks';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element not found');
}
// eslint-disable-next-line @typescript-eslint/no-floating-promises
enableMocking().then(() => {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
